import { render, staticRenderFns } from "./adminsettings.vue?vue&type=template&id=b13100aa&scoped=true"
import script from "./adminsettings.vue?vue&type=script&lang=js"
export * from "./adminsettings.vue?vue&type=script&lang=js"
import style0 from "./adminsettings.vue?vue&type=style&index=0&id=b13100aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13100aa",
  null
  
)

export default component.exports